import t from '@rcm/i18n-client';
import { useCurrentOrderAddItemsMutationWithContext } from '@reliv/redux-global-cart';
import { GtagCartUpdateMethod } from 'google-analytics';
import React, { useCallback } from 'react';
import { Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import useResultsQueries from '../../hooks/useResultsQueries';
import { selectSkusSelectedQuantities } from '../../slices/skusSelected';

const OrderNowButton = () => {
    const skus = useSelector(selectSkusSelectedQuantities);
    const resultsQueries = useResultsQueries();
    const [currentOrderAddItems, currentOrderAddItemsMutation] = useCurrentOrderAddItemsMutationWithContext();

    const handleClick = useCallback(async () => {
        await (currentOrderAddItems({
            cart_update_method: GtagCartUpdateMethod.FIELD_TRANSFER_CALCULATOR,
            skus: Object.entries(skus)
                .filter(([, qty]) => qty )
                .map(([ skuNumber, qty ]) => ({ qty, skuNumber }))
        }).unwrap());
        window.location = '/cart#/my-cart' as any;
    }, [skus, currentOrderAddItems]);

    return <Button
        disabled={
            !resultsQueries.isSuccess ||
            currentOrderAddItemsMutation.isLoading ||
            currentOrderAddItemsMutation.isSuccess
        }
        onClick={handleClick}
    >{t('Order Items Now')}</Button>
}

export default OrderNowButton;
